import { WikiStructure } from './types.js';

function transformWikiResponse(dto) {
    var blocks = dto.blocks.map(function (block) {
        switch (block.type) {
            case 'header':
                var header = {
                    kind: WikiStructure.Header,
                    level: block.data.level,
                    text: block.data.text,
                    anchor: block.data.anchor,
                };
                return header;
            case 'paragraph':
                var paragraph = {
                    kind: WikiStructure.Paragraph,
                    text: block.data.text,
                };
                return paragraph;
            case 'image':
                var image = {
                    kind: WikiStructure.Image,
                    url: block.data.file.url,
                    caption: block.data.caption,
                };
                return image;
            case 'table':
                var table = {
                    kind: WikiStructure.Table,
                    headings: getTableHeadings(block.data),
                    body: getTableBody(block.data),
                };
                return table;
            case 'list':
                var list = {
                    kind: WikiStructure.List,
                    style: block.data.style,
                    items: block.data.items,
                };
                return list;
            case 'nestedlist':
                var nestedList = {
                    kind: WikiStructure.NestedList,
                    style: block.data.style,
                    items: block.data.items,
                };
                return nestedList;
            case 'button':
                var button = {
                    kind: WikiStructure.Button,
                    url: block.data.link,
                    text: block.data.text,
                };
                return button;
            case 'raw':
                var html = {
                    kind: WikiStructure.Html,
                    content: block.data.html,
                };
                return html;
            default:
                return null;
        }
    })
        .filter(function (block) { return block !== null; });
    return {
        blocks: blocks,
        title: dto.title,
    };
}
function getTableHeadings(data) {
    if (data.withHeadings) {
        return data.content[0];
    }
    else {
        return undefined;
    }
}
function getTableBody(data) {
    if (data.withHeadings) {
        return data.content.slice(1);
    }
    else {
        return data.content;
    }
}

export { transformWikiResponse };
